module.exports = __webpack_public_path__ + "static/media/Ghost Town.a4aa0acb.mp3";